import { Component, ViewChild, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProposalsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IFROportunitats } from '../../oportunitats/oportunitats.interfaces';
import { OportunitatsService } from '../../oportunitats/oportunitats.service';

import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-oportunitats',
  templateUrl: './dialog.component.oportunitats.html',
  styleUrls: ['./dialog.component.oportunitats.scss'],
  providers: [OportunitatsService, ProposalsService]
})
export class DialogOportunitats {
  public error: string = '';
  public showAsyncProgress: boolean = false;
  public editOportunitatsData: IFROportunitats;
  public userInfo: any = {};
  //public possibleAmbits: Array<string>;
  public possibleAmbits: { codi: string; text: string; }[];

  public possibleTipus: Array<string>;
  public possibleTipusExpressio: Array<string>;
  public possibleTecnics: Array<{value:string, text:string}>;
  public coordinadors: Array<string>;
  public tecnics_suport: Array<string>;
  public opcio: number;
  public rol: any = 0;
  public quillPos: number = 0;
  public dia: string = null;

  @ViewChild('quillEditor', { static: false }) editor;

  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProposalsService, private tokenStorage: TokenStorageService, private oportunitatsService: OportunitatsService, public dialogRef: MatDialogRef<DialogOportunitats>, @Inject(MAT_DIALOG_DATA) public data: any){ 
   this.editOportunitatsData = data;
   this.userInfo = this.tokenStorage.getUser();
   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
  }

  formatLabel(value: number) { return value}

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {var desar = true;
    if(this.editOportunitatsData.titol == "" || !this.editOportunitatsData.titol){
      desar = false;
      this.translate.get('oportunitats.msgcodi').subscribe((res: string) => {
         alert(res);
      });
    }
    if(this.editOportunitatsData.estat == "" || !this.editOportunitatsData.estat){
      desar = false;
      this.translate.get('oportunitats.msgestat').subscribe((res: string) => {
         alert(res);desar = false;
      });
    }
    this.editOportunitatsData.coordinador = (this.coordinadors[0]?this.coordinadors.join(" / "):null);
    this.editOportunitatsData.tecnic_suport = (this.tecnics_suport[0]?this.tecnics_suport.join(" / "):null);
    if(desar)this.dialogRef.close(this.editOportunitatsData);
  }

  close(): void {
    this.dialogRef.close(this.editOportunitatsData);
  }

  ngOnInit(){
   this.rol = this.tokenStorage.getRol();
   if(!this.editOportunitatsData.data_limit_presentacio)this.editOportunitatsData.data_limit_presentacio = moment().format("YYYY-MM-DD");
   if(!this.editOportunitatsData.data_publicacio)this.editOportunitatsData.data_publicacio = moment().format("YYYY-MM-DD");
   //this.dataService.getAmbits().subscribe(ambits => this.possibleAmbits = ambits, err => console.log(err));
   this.dataService.getAmbits().subscribe(ambits => {
      this.possibleAmbits = ambits.map(nomCatala => ({
        codi: nomCatala["value"], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('ambitsRaw', nomCatala["text"]) // ← només es mostra traduït
      }));
   });
   this.dataService.getTipus().subscribe(tipus => this.possibleTipus = tipus, err => {return;});
   this.dataService.getTipusExpressio().subscribe(tipus => this.possibleTipusExpressio = tipus, err => {return;});
   this.dataService.getAutocomplete('tecnicMcrit').subscribe(tecnic => this.possibleTecnics = tecnic, err => {return;});
   this.coordinadors = (this.editOportunitatsData && this.editOportunitatsData.coordinador?this.editOportunitatsData.coordinador.split(" / "):[]);
   this.tecnics_suport = (this.editOportunitatsData && this.editOportunitatsData.tecnic_suport?this.editOportunitatsData.tecnic_suport.split(" / "):[]);
   if(!this.editOportunitatsData.memoria_tecnica)this.editOportunitatsData.memoria_tecnica = 'Si';
   if(!this.editOportunitatsData.perfils_tecnics)this.editOportunitatsData.perfils_tecnics = 'Parcialment';
   if(!this.editOportunitatsData.puntuacio_possible)this.editOportunitatsData.puntuacio_possible = 50;
   }

  crear(){
    this.translate.get('oportunitats.msgcodi').subscribe((res: string) => {
     if(!this.editOportunitatsData.codi){alert(res);return};
     if(this.opcio == 1)this.editOportunitatsData.id ='PRE';
     if(this.opcio == 2)this.editOportunitatsData.id ='PRO';
     if(this.opcio == 1 || this.opcio == 2)this.desar();
    });
  }

  setPos(event){
    if(event.range)this.quillPos = event.range.index;
    else if(event.oldRange)this.quillPos = event.oldRange.index;
  }

  afegir(){
   if(this.editOportunitatsData.nota){
     if(this.editOportunitatsData.nota.indexOf("[" + this.dia + "]") == -1)
       this.editOportunitatsData.nota = "("+this.userInfo.name+"): <p>&nbsp;</p>" + (this.editOportunitatsData.nota?this.editOportunitatsData.nota:'') + "<p>&nbsp;</p>";
   }
   else
       this.editOportunitatsData.nota = "[" + this.dia + "] ("+this.userInfo.name+"): <p>&nbsp;</p>" + (this.editOportunitatsData.nota?this.editOportunitatsData.nota:'') + "<p>&nbsp;</p>";
  }

}
